module.exports = __webpack_public_path__ + "img/symbol_questionblue.7f9f0070.png";